import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetShipsResponse } from '../../../../../interfaces/src/lib/types/index';

export interface BookingContentFragmentSliceState {
  ship: GetShipsResponse | null;
}

const initialState: BookingContentFragmentSliceState = {
  ship: null,
};

const bookingContentFragmentSlice = createSlice({
  name: 'bookingContentFragment',
  initialState: initialState,
  reducers: {
    setShipCF: (state, action: PayloadAction<GetShipsResponse>) => {
      state.ship = action.payload;
    },
  },
});

export const { setShipCF } = bookingContentFragmentSlice.actions;
export default bookingContentFragmentSlice.reducer;
